import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import InicioAdm from "./InicioAdm";
import { InicioDocente } from "./InicioDocente";
import { InicioEstudiante } from "./InicioEstudiante";

export const Inicio = () => {
  const rol = useSelector((store) => store.usuario.rol);
  switch (rol) {
    case "SADM":
    case "ADM":
      return <InicioAdm />;
    case "DOC":
      return <InicioDocente />;
    case "EST":
      return <InicioEstudiante />;
    default:
      return <Navigate to="/" />;
  }
};
